<div class="flex flex-col gap-4">
  @if (isCurrentLocationLoading) {
    <app-loader/>
  }
  @if (!hideCurrentLocation) {
    <app-address-auto-complete-result
      icon="location-crosshairs"
      [main]="myLocationText"
      (onResultClick)="onCurrentLocationClick.emit()"
      />
  }
    @if (isInMobileView()) {
      <!-- a11y: "Search on map" opens the map-picker dialog -> aria-haspopup="dialog". -->
      <app-address-auto-complete-result icon="map-location-dot" [main]="searchOnMapText" [disabled]="!searchOnMapEnabled" ariaHasPopup="dialog" (onResultClick)="onMapClick.emit()" />
    }

    <div class="flex flex-col">
      <h3 class="text-base">{{favoriteAddressesText}}</h3>
      <app-favorite-locations [favoriteAddresses]="favoriteAddresses" (onHomeClick)="onHomeClick.emit($event)"
        (onWorkClick)="onWorkClick.emit($event)" />
      </div>

      <div class="flex flex-col">
        <h3 class="text-base">{{lastSearchesText}}</h3>
        <div class="flex flex-col gap-2">
          @for (address of favoriteAddresses?.lastSearches; track address) {
            <app-address-auto-complete-result [address]="address"
              [main]="address.addressDetails.label" [sub]="address.addressDetails.city"
              (onResultClick)="onLastSearchClick.emit(address)" />
          }
        </div>
      </div>
    </div>
